/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./packetList.vue?vue&type=template&id=d7242e40&scoped=true"
import script from "./packetList.vue?vue&type=script&lang=js"
export * from "./packetList.vue?vue&type=script&lang=js"
import style0 from "./packetList.vue?vue&type=style&index=0&id=d7242e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7242e40",
  null
  
)

export default component.exports